export const NimbraGreyLight = {
    50: '#E6EDFA',
    100: '#E1E8F6',
    200: '#DBE2EF',
    300: '#CED5E2',
    400: '#AEB5C2',
    500: '#9198A6',
    600: '#6C7280',
    700: '#59606E',
    800: '#3D4451',
    900: '#202631',
    1000: '#14161A',
}

export const NimbraGreyDark = {
    50: '#E6EDFA',
    100: '#E1E8F6',
    200: '#DBE2EF',
    300: '#CED5E2',
    400: '#AEB5C2',
    500: '#9198A6',
    600: '#6C7280',
    700: '#59606E',
    800: '#3D4451',
    900: '#202631',
    1000: '#14161A',
}

export const NimbraBlueLight = {
    50: '#E0ECFD',
    100: '#B2D1FF',
    200: '#7EAEF7',
    300: '#448AFA',
    400: '#1F71FF',
    500: '#0055FF',
    600: '#0041E5',
    700: '#0730C5',
    800: '#001EAA',
    900: '#052159',
}

export const NimbraBlueDark = {
    50: '#E7EDF6',
    100: '#C1D4F0',
    200: '#9AB4DB',
    300: '#6A93D4',
    400: '#4B7DD2',
    500: '#3366CC',
    600: '#2E55B7',
    700: '#30479C',
    800: '#223488',
    900: '#182746',
}
